import React from 'react';
import PropTypes from 'prop-types';
import { SERVER_ERRORS } from 'products/nomad_insurance/constants';
import { ErrorAlert, IntercomLink } from './styled';

const ErrorMessage = ({ error, className }) => {
  const err = SERVER_ERRORS[error?.type] || SERVER_ERRORS.DEFAULT;
  if (error?.type === 'VERIFICATION__FAILED') {
    return (
      <ErrorAlert variant="warning" label="Application in progress">
        We’ve received your application and your data has been saved. We will be in touch
        within 24 hours after verifying your application details (please allow up to 48
        hours on weekends and public holidays). Thanks for your patience, expect to hear
        from us very soon!
      </ErrorAlert>
    );
  }
  return (
    <ErrorAlert label={error?.title || err.title} variant="danger" className={className}>
      {error?.message || (
        <>
          Something went wrong. Please contact{' '}
          <IntercomLink onClick={() => window.Intercom('showNewMessage')}>
            customer service
          </IntercomLink>
          .
        </>
      )}
    </ErrorAlert>
  );
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string
  })
};

export default ErrorMessage;
